// Constants
import { ENV } from 'constants/environment';
// Types
type IConfigProperties = {
  domain: string;
};
type IIdentityProperties = {
  id?: string;
  email?: string;
  name?: string;
  company?: string;
  avatar?: string;
};
interface IWoopra {
  config(properties: IConfigProperties): void;
  identify(properties: IIdentityProperties): void;
  push(callback?: Function): void;
  track(eventName?: string, properties?: object, callback?: Function): void;
}
declare const woopra: IWoopra; // Loaded in index.html

//
function config(properties: IConfigProperties) {
  if (ENV.ANALYTICS_ENABLED) {
    return woopra.config(properties);
  }
  console.warn(
    'Utility:Woopra',
    'config(...) is not functional because analystics is disabled in environment constants.'
  );
}

function identify(properties: IIdentityProperties) {
  if (ENV.ANALYTICS_ENABLED) {
    return woopra.identify(properties);
  }
  console.warn(
    'Utility:Woopra',
    'identify(...) is not functional because analystics is disabled in environment constants.'
  );
}

function push(callback?: Function) {
  if (ENV.ANALYTICS_ENABLED) {
    return woopra.push(callback);
  }
  console.warn(
    'Utility:Woopra',
    'push(...) is not functional because analystics is disabled in environment constants.'
  );
}

function track(eventName?: string, properties?: object, callback?: Function) {
  if (ENV.ANALYTICS_ENABLED) {
    return woopra.track(eventName, properties, callback);
  }
  console.warn(
    'Utility:Woopra',
    'track(...) is not functional because analystics is disabled in environment constants.'
  );
}

export { config, identify, push, track };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utilities/woopra.ts